export const ACCESS_TOKEN = 'jwt'
export const REFRESH_TOKEN = 'jwt_refresh_token'
export const GOOGLE_ACCESS_TOKEN = 'google_access_token'
export const GOOGLE_REFRESH_TOKEN = 'google_refresh_token'
export const AUTOMATION_TOKEN = 'automation_token'
